export default {
  COLLECTION: 'collection',
  REDEMPTION: 'redemption',
  OFF: 'off',
};
